import { render, staticRenderFns } from "./selfServiceMeal.vue?vue&type=template&id=1f124f48&scoped=true&"
import script from "./selfServiceMeal.vue?vue&type=script&lang=js&"
export * from "./selfServiceMeal.vue?vue&type=script&lang=js&"
import style0 from "./selfServiceMeal.vue?vue&type=style&index=0&id=1f124f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f124f48",
  null
  
)

export default component.exports